module.exports = __webpack_public_path__ + "static/media/user.51cf6f45.svg";